import { integrationsClient } from '~/api/client';
import { endpoints } from '~/api/endpoints';

import type { ApiResponse } from '../types/connection.types';
import type { OnboardingStatusResponse } from '../types/onboarding-status.types';

/** Fetch aggregated onboarding status (channel-connection + per-channel
 *  catalog-import state). Single source of truth for the post-login
 *  redirect between `/onboarding`, `/onboarding/complete-import`,
 *  and `/experiments`. */
export async function getOnboardingStatus(): Promise<OnboardingStatusResponse> {
  const res = await integrationsClient
    .get(endpoints.integration.onboardingStatus())
    .json<ApiResponse<OnboardingStatusResponse>>();
  return res.data;
}
